export const createPasswordFields = {
  password: 'Nova Senha',
  passwordConfirm: 'Confirmar nova senha',
  errors: {
    password: {
      invalid: 'A nova senha não atende aos critérios necessários',
      minLength: 'A senha deve conter no mínimo 6 caracteres',
      lowerCase: 'A senha deve conter uma letra minúscula',
      upperCase: 'A senha deve conter uma letra maiúscula',
      number: 'A senha deve conter número',
      specialChars: 'A senha deve conter caractere especial',
      required: 'Este campo é obrigatório',
    },
    confirmPassword: {
      mismatch: 'A confirmação da senha não está idêntica à nova senha',
      required: 'Este campo é obrigatório',
    },
  },
};
